import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsis } from "@fortawesome/free-solid-svg-icons";

import { IconComponent } from "./types";

export const MoreOptionsIcon: IconComponent = (props) => {
  return <FontAwesomeIcon {...props} icon={faEllipsis} color="#94979B" />;
};
